import { Places } from '../../../../route-consts';
import { MonitoringKeys } from '../monitoring.key';
/**
 * A LISTAGEM de monitoramentos compartilhados.
 *
 * Sem parametro proprio: o filtro, a ordenacao e a pagina sao do CONCEITO, e ela os
 * consome por heranca. Ver `MonitoringPresenter`.
 */
export class MonitoringListKeys extends MonitoringKeys {
    get place() {
        return Places.monitoringList;
    }
}
//# sourceMappingURL=monitoring-list.key.js.map